var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Paper from "@material-ui/core/Paper";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { affinityColors } from "..";
var useStyles = makeStyles(function (theme) { return ({
    card: {
        marginBottom: theme.spacing(1)
    },
    expand: {
        transform: "rotate(0deg)",
        marginLeft: "auto",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        })
    },
    expandOpen: {
        transform: "rotate(180deg)"
    }
}); });
/**
 * Expanding card
 * Modified from example here: https://material-ui.com/components/cards/#complex-interaction
 * Note this is different to ExpandingSection as they can exist singularly.
 * The former is designed for accordions.
 *
 * @param title
 * @param subtitle
 * @param avatar
 * @param defaultExpanded
 * @param onChange
 * @param children
 * @param other
 * @returns {*}
 * @constructor
 */
export function ExpandingCard(_a) {
    var _b;
    var title = _a.title, subtitle = _a.subtitle, avatar = _a.avatar, defaultExpanded = _a.defaultExpanded, controlledExpanded = _a.expanded, onHeaderClick = _a.onHeaderClick, children = _a.children, onExpand = _a.onExpand, other = __rest(_a, ["title", "subtitle", "avatar", "defaultExpanded", "expanded", "onHeaderClick", "children", "onExpand"]);
    var classes = useStyles();
    var controlledByParent = typeof onHeaderClick === "function";
    var _c = React.useState(false), expanded = _c[0], setExpanded = _c[1];
    if (controlledByParent) {
        // expansions is controlled by parent
        expanded = !!controlledExpanded;
        // @ts-ignore
        setExpanded = onHeaderClick;
    }
    else {
        // TODO: Tidy this up.
        // React Hook "React.useState" is called conditionally. React Hooks must be called in the exact same order in every component render  react-hooks/rules-of-hooks
        // [expanded, setExpanded] = React.useState(false);
    }
    React.useEffect(function () {
        if (!controlledByParent)
            setExpanded(!!defaultExpanded);
    }, [onHeaderClick, controlledByParent, defaultExpanded]);
    var handleExpandClick = function () {
        setExpanded(!expanded);
        if (onExpand)
            onExpand();
    };
    return (React.createElement(Paper, __assign({ elevation: 2, className: classes.card }, other),
        React.createElement(CardHeader, { avatar: avatar, action: React.createElement(IconButton, { className: clsx(classes.expand, (_b = {},
                    _b[classes.expandOpen] = expanded,
                    _b)), "aria-expanded": expanded, "aria-label": "show more" },
                React.createElement(ExpandMoreIcon, null)), title: title, subheader: subtitle, onClick: handleExpandClick }),
        React.createElement(Collapse, { in: expanded, timeout: "auto" },
            React.createElement(CardContent, { style: { backgroundColor: affinityColors.grey50.value } }, children))));
}
ExpandingCard.propTypes = {
    /**
     * The title of the card
     */
    title: PropTypes.string,
    /**
     * Subtitle of the card
     */
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    /**
     * Icon / Avatar displayed top left on the card header
     */
    avatar: PropTypes.element,
    /**
     * Sets whether the card is open or not
     * Ignored when component is uncontrolled
     */
    expanded: PropTypes.bool,
    /**
     * Default expansion state
     * Ignored when component is controlled
     */
    defaultExpanded: PropTypes.bool,
    /**
     * Callback fired when header clicked. Component is uncontrolled when undefined.
     * Signature: function(expanded: boolean) => void
     */
    onHeaderClick: PropTypes.func,
    /**
     * Optional function passed in for if wanting to add a custom action when expanding the card.
     */
    onExpand: PropTypes.func
};
//# sourceMappingURL=ExpandingCard.js.map